// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../Members/MemberList.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reuse same styles as MemberList */

.worship-id-badge {
  display: inline-block;
  background: #e9ecef;
  color: #495057;
  font-family: 'Courier New', monospace;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 2px 8px;
  border-radius: 4px;
  letter-spacing: 1px;
}

.badge-purple {
  background-color: #7c3aed;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
}

.badge-info {
  background-color: #0ea5e9;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
}

.badge-warning {
  background-color: #f59e0b;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
}

.minor-member-list-container {
  padding: 0;
}

.btn-purple {
  background-color: #7c3aed;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
}
.btn-purple:hover { background-color: #6d28d9; color: #fff; }
`, "",{"version":3,"sources":["webpack://./src/components/MinorMembers/MinorMemberList.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAGpC;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;AACA,oBAAoB,yBAAyB,EAAE,WAAW,EAAE","sourcesContent":["/* Reuse same styles as MemberList */\n@import '../Members/MemberList.css';\n\n.worship-id-badge {\n  display: inline-block;\n  background: #e9ecef;\n  color: #495057;\n  font-family: 'Courier New', monospace;\n  font-weight: 700;\n  font-size: 0.95rem;\n  padding: 2px 8px;\n  border-radius: 4px;\n  letter-spacing: 1px;\n}\n\n.badge-purple {\n  background-color: #7c3aed;\n  color: #fff;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n}\n\n.badge-info {\n  background-color: #0ea5e9;\n  color: #fff;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n}\n\n.badge-warning {\n  background-color: #f59e0b;\n  color: #fff;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n}\n\n.minor-member-list-container {\n  padding: 0;\n}\n\n.btn-purple {\n  background-color: #7c3aed;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  text-decoration: none;\n}\n.btn-purple:hover { background-color: #6d28d9; color: #fff; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
